import { useStartAPetitionPageState } from 'src/app/pages/startAPetitionV2/pageContext';

type PageState = ReturnType<typeof useStartAPetitionPageState>;
type Result = ModelHookResult<undefined, { matches: PageState['actions']['matches'] }>;

export function usePageBody(): Result {
	const { actions } = useStartAPetitionPageState();

	return { actions: { matches: actions.matches } };
}
